import { computed, type MaybeRefOrGetter, toValue } from "vue";
import type { TravelOrderDto } from "@/api/trips/dto/trip.dto";

export function useTravelOrder(travelOrder: MaybeRefOrGetter<TravelOrderDto>) {
  const travelOrderRef = computed(() => toValue(travelOrder));

  const totalPaymentsAmount = computed(() => {
    return travelOrderRef.value.payments.reduce((acc, payment): number => {
      return acc + Number(payment.amount);
    }, 0);
  });

  return {
    totalPaymentsAmount,
  };
}
